import { Injectable } from '@angular/core';
import {EventsService} from '../_services/events.service';
import {TabledataService} from '../_services/tabledata.service';
import {PointStyle} from './styles/point-style';
import {LineStyle} from './styles/line-style';
import {PolygonStyle} from './styles/polygon-style';
import { HttpClient }       from '@angular/common/http';
import { Observable }     from 'rxjs';
import { Subject }    from 'rxjs';
import { map } from 'rxjs/operators';
import {GlobalsService} from '../_services/globals.service';
import { KeycloakService } from '../login/keycloak.service';

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import HeatmapLayer from 'ol/layer/Heatmap';
import TileWMS from 'ol/source/TileWMS';
import VectorSource from 'ol/source/Vector';
import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';
import WFS from 'ol/format/WFS';
import GML from 'ol/format/GML';
import Select from 'ol/interaction/Select';
import TileState from 'ol/TileState';

import { getTransform } from 'ol/proj';
import { applyTransform, getCenter } from 'ol/extent';
import { all as loadingStrategyAll } from 'ol/loadingstrategy';

import ScaleLine from 'ol/control/ScaleLine';
import ZoomToExtent from 'ol/control/ZoomToExtent';
import { defaults as defaultControls } from 'ol/control/defaults';

import { shiftKeyOnly } from 'ol/events/condition';

import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import Point from 'ol/geom/Point';

import Feature from 'ol/Feature';
import { Style, Circle as CircleStyle, Fill, Stroke } from 'ol/style';
import { transform, transformExtent } from 'ol/proj';

// OFM: OpenFreeMap vektorska podlaga (npm install ol-mapbox-style@13.1.1 --save-exact)
import { MapboxVectorLayer } from 'ol-mapbox-style';
import LayerGroup from 'ol/layer/Group';

// OFM: javni ortofoto GURS za celo Slovenijo (spodnji sloj v HYBRID).
const GURS_ORTHO_URL = 'https://storitve.eprostor.gov.si/ows-pub-wms/SI.GURS.ZPDZ/ows';
const GURS_ORTHO_LAYER = 'DOF5';

const LAYER_BLEND_MODES: { [layer: string]: string } = {
    'elek:202406_sun_mask_hourly_average': 'multiply',
};

// OFM: ORTOFOTO MOL (v HYBRID nad GURS, samo na svojem območju).
// Sloj je v GeoServerju zaklenjen (bere ga samo interni uporabnik backenda),
// zato ga frontend NE kliče direktno, ampak prek /api/ortho/mol:
// KrakenD in backend preverita vlogo (admin/mol) in ploščico pobereta z GeoServerja.
const OWN_ORTHO_LAYER = 'elek:pof_mol_2025';
const OWN_ORTHO_API_PATH = '/api/ortho/mol';
// OFM: obseg ortofota MOL (lon/lat); ploščice se izven njega ne zahtevajo.
const OWN_ORTHO_EXTENT_LONLAT = [14.40, 45.97, 14.77, 46.15];

// OFM: KDO VIDI VAŠ ORTOFOTO (MOL). Vsi ostali vidijo povsod samo GURS.
// Uporabnik ga vidi, če ima v Keycloak žetonu vsaj eno od teh vlog ALI skupin
// (primerjava ne loči velikih in malih črk). Imena prilagodi svojim v Keycloaku.
// Seznam vlog mora biti enak kot v backendu (OrthoResource.ORTHO_ROLES in @KrakenD roles).
const OWN_ORTHO_ROLES: string[] = ['admin', 'mol'];
const OWN_ORTHO_GROUPS: string[] = ['/MOL', 'MOL'];

// OFM: sloji iz stila Liberty, ki se izrišejo NAD ortofotom (ceste, meje, imena).
// Površine (gozd, voda, stavbe, ozadje) so izpuščene, da se vidi posnetek.
const OFM_HYBRID_OVERLAY_LAYERS: string[] = [
    'waterway_river',
    'tunnel_motorway_link', 'tunnel_link', 'tunnel_minor', 'tunnel_secondary_tertiary',
    'tunnel_trunk_primary', 'tunnel_motorway',
    'road_motorway_link_casing', 'road_link_casing', 'road_minor_casing',
    'road_secondary_tertiary_casing', 'road_trunk_primary_casing', 'road_motorway_casing',
    'road_motorway_link', 'road_service_track', 'road_link', 'road_minor',
    'road_secondary_tertiary', 'road_trunk_primary', 'road_motorway', 'road_major_rail',
    'bridge_motorway_link_casing', 'bridge_link_casing', 'bridge_street_casing',
    'bridge_secondary_tertiary_casing', 'bridge_trunk_primary_casing', 'bridge_motorway_casing',
    'bridge_motorway_link', 'bridge_link', 'bridge_street', 'bridge_secondary_tertiary',
    'bridge_trunk_primary', 'bridge_motorway', 'bridge_major_rail',
    'boundary_3', 'boundary_2', 'boundary_disputed',
    'waterway_line_label', 'water_name_point_label', 'water_name_line_label',
    'highway-name-path', 'highway-name-minor', 'highway-name-major', 'highway-shield-non-us',
    'label_other', 'label_village', 'label_town', 'label_state', 'label_city',
    'label_city_capital', 'label_country_3', 'label_country_2', 'label_country_1',
];

// OFM: stili OpenFreeMap. Ključ = vrednost, ki jo pošlješ v setMapType().
// OFM: obseg Slovenije z malo roba (lon/lat), preračunan v 3857.
// Karta se ne da premakniti ali oddaljiti izven tega območja,
// podlage pa izven njega ne nalagajo ploščic (hitreje).
const SLO_EXTENT = transformExtent([13.2, 45.3, 16.8, 47.0], 'EPSG:4326', 'EPSG:3857');

const OFM_STYLES: { [type: string]: string } = {
    NORMAL:   'https://tiles.openfreemap.org/styles/liberty',
    CLASSIC:  'https://tiles.openfreemap.org/styles/bright',
    POSITRON: 'https://tiles.openfreemap.org/styles/positron',
};

@Injectable()
export class Mapapi
{
    map:any;
    selectInteractionFeature:any;
    layers: { [id: string] : any; } = {};
    pointstyle:PointStyle;
    linestyle:LineStyle;
    pointstyleSelected:PointStyle;
    polygonStyle:PolygonStyle;
    linestyleSelected:LineStyle;
    wmsBaseLayerActive:any;
    bhsMapLoad:Subject<Mapapi>;
    $bhsMapLoad:Observable<Mapapi>;
    isdisablemapclick:boolean = false;

    // OFM: karta je zdaj v Web Mercatorju (to zahteva OpenFreeMap).
    static activeEPSG =  'EPSG:3857';
    // OFM: koordinatni sistem vaših podatkov na GeoServerju / v bazi.
    static dataEPSG = 'EPSG:3912';

    // OFM: predpomnilnik OpenFreeMap slojev, da se stil ne nalaga ob vsaki menjavi.
    private ofmLayers: { [type: string]: any } = {};

    // OFM: sloj z vašim ortofotom in ali ga trenutni uporabnik sme videti.
    private ownOrthoLayer: any = null;
    private ownOrthoAllowed: boolean | null = null; // null = preberi iz Keycloaka

    public constructor(
    private evs: EventsService,
    private http: HttpClient,
    private tabledataService: TabledataService,
    private gs: GlobalsService
    ) {
    this.pointstyle = new PointStyle();
    this.linestyle = new LineStyle();
    this.polygonStyle = new PolygonStyle();
    this.bhsMapLoad = new Subject<any>();
    this.$bhsMapLoad = this.bhsMapLoad.asObservable();

    proj4.defs(
        'EPSG:3912',
        '+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +towgs84=430.8554,121.4779,459.6256,4.3787,4.3716,-11.9863,17.3666 +units=m +no_defs'
    );
    proj4.defs(
        'EPSG:3794',
        '+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
    );

    // IMPORTANT: registers proj4 definitions into OpenLayers
    register(proj4);
    }

    private cacheSeq = 0;

    private nextCacheKey(): string {
        this.cacheSeq += 1;
        return `${Date.now()}_${this.cacheSeq}`;
    }

    private refreshSource(layerOrSource: any): void {
        const src = typeof layerOrSource?.getSource === 'function'
            ? layerOrSource.getSource()
            : layerOrSource;

        if (!src) return;

        if (typeof src.updateParams === 'function') {
            src.updateParams({ _ck: this.nextCacheKey() });
        }

        if (typeof src.refresh === 'function') {
            src.refresh();
        }
    }

    public refreshLayerById(id: string): void {
        const layer = this.getLayerById(id);
        if (!layer) return;
        this.refreshSource(layer);
    }

    // OFM: ustvari (ali vrne že ustvarjen) OpenFreeMap sloj za dani tip.
    private getOfmLayer(type: string): any {
        if (!this.ofmLayers[type]) {
            const layer = new MapboxVectorLayer({
                styleUrl: OFM_STYLES[type],
                extent: SLO_EXTENT,
            });
            layer.set('basemap', true);
            layer.set('id', 'basemap_' + type);
            this.ofmLayers[type] = layer;
        }
        return this.ofmLayers[type];
    }

    // OFM: hibridna podlaga = ortofoto spodaj + OpenFreeMap ceste in imena zgoraj.
    private createOfmLabelsLayer(): any {
        return new MapboxVectorLayer({
            styleUrl: OFM_STYLES['NORMAL'],
            layers: OFM_HYBRID_OVERLAY_LAYERS,
            background: false,
        });
    }

    // OFM: ali trenutni uporabnik sme videti vaš ortofoto (vloge/skupine iz Keycloaka).
    // To je samo za prikaz; pravo preverjanje naredita KrakenD in backend.
    private isOwnOrthoAllowed(): boolean {
        if (this.ownOrthoAllowed !== null) return this.ownOrthoAllowed;

        const token: any = (KeycloakService as any).auth?.authz?.tokenParsed;
        if (!token) return false;

        const lower = (a: any[]) => (a || []).map((x: any) => String(x).toLowerCase());
        const roles: string[] = lower(token.realm_access?.roles);
        Object.values(token.resource_access || {}).forEach((r: any) => roles.push(...lower(r?.roles)));
        const groups: string[] = lower(token.groups);

        const wantRoles = lower(OWN_ORTHO_ROLES);
        const wantGroups = lower(OWN_ORTHO_GROUPS);

        return roles.some(r => wantRoles.includes(r)) || groups.some(g => wantGroups.includes(g));
    }

    // OFM: ročna nastavitev (npr. če se občina uporabnika bere iz vašega backenda).
    // Pokliči setOwnOrthoAllowed(true/false) po prijavi; null = spet odloča Keycloak.
    public setOwnOrthoAllowed(allowed: boolean | null): void {
        this.ownOrthoAllowed = allowed;
        if (this.ownOrthoLayer) {
            this.ownOrthoLayer.setVisible(this.isOwnOrthoAllowed());
        }
    }

    // OFM: veljaven žeton za /api/ortho/mol (po potrebi ga osveži).
    private async getFreshToken(): Promise<string> {
        const kc: any = (KeycloakService as any).auth?.authz;
        try { await kc?.updateToken(30); } catch { /* uporabi obstoječega */ }
        return kc?.token ?? '';
    }

    // OFM: HYBRID = ortofoto GURS (cela Slovenija, spodaj)
    //      + ortofoto MOL nad Ljubljano (samo za admin/mol, prek /api/ortho/mol)
    //      + OpenFreeMap ceste in imena (zgoraj).
    private getHybridLayer(): any {
        if (!this.ofmLayers['HYBRID']) {
            const gursOrtho = new TileLayer({
                source: new TileWMS({
                    url: GURS_ORTHO_URL,
                    params: {
                        LAYERS: GURS_ORTHO_LAYER,
                        FORMAT: 'image/jpeg',
                        TRANSPARENT: false,
                    },
                    serverType: 'geoserver',
                    attributions: '© GURS',
                }),
            });

            const ownOrthoSource = new TileWMS({
                url: window.location.origin + OWN_ORTHO_API_PATH,
                params: {
                    LAYERS: OWN_ORTHO_LAYER,
                    // JPEG, kjer je slika, prosojno izven nje (da se vidi GURS).
                    FORMAT: 'image/vnd.jpeg-png',
                    TRANSPARENT: true,
                    TILED: true,
                    // GeoWebCache WMS podpira samo WMS 1.1.1 (parameter SRS namesto CRS).
                    VERSION: '1.1.1',
                },
                serverType: 'geoserver',
            });

            // OFM: <img> ne zna poslati žetona, zato ploščico naložimo s fetch + Authorization.
            // Če ploščica ne uspe (npr. 401/403), ostane prazna in pod njo se vidi GURS.
            ownOrthoSource.setTileLoadFunction(async (tile: any, src: string) => {
                try {
                    const token = await this.getFreshToken();
                    const res = await fetch(src, { headers: { Authorization: `Bearer ${token}` } });
                    if (!res.ok) throw new Error(String(res.status));
                    const objUrl = URL.createObjectURL(await res.blob());
                    const img = tile.getImage() as HTMLImageElement;
                    img.onload = () => URL.revokeObjectURL(objUrl);
                    img.src = objUrl;
                } catch {
                    tile.setState(TileState.ERROR);
                }
            });

            const ownOrtho = new TileLayer({
                // OFM: skrit sloj ne pošilja nobenih zahtevkov.
                visible: this.isOwnOrthoAllowed(),
                extent: transformExtent(OWN_ORTHO_EXTENT_LONLAT, 'EPSG:4326', Mapapi.activeEPSG),
                source: ownOrthoSource,
            });

            const group = new LayerGroup({
                layers: [gursOrtho, ownOrtho, this.createOfmLabelsLayer()],
                extent: SLO_EXTENT,
            });
            group.set('basemap', true);
            group.set('id', 'basemap_HYBRID');
            this.ofmLayers['HYBRID'] = group;

            this.ownOrthoLayer = ownOrtho;
        }
        return this.ofmLayers['HYBRID'];
    }

    public createMap(id: string): void {
        const self = this;

        // OFM: standardni Web Mercator pogled. Stari center (GK) je preračunan v 3857,
        // stari zoom 5 (2,8 m/px) ustreza približno zoomu 15.
        const mapView = new View({
            projection: Mapapi.activeEPSG,
            center: transform([388255, 43463], Mapapi.dataEPSG, Mapapi.activeEPSG),
            zoom: 15,
            minZoom: 8,
            maxZoom: 21, // OFM: največja povečava (prej 20)
            // OFM: omeji premikanje in oddaljevanje na Slovenijo.
            extent: SLO_EXTENT,
            showFullExtent: true,
        });

        // OFM: privzeta podlaga je OpenFreeMap Liberty.
        this.wmsBaseLayerActive = this.getOfmLayer('NORMAL');

        this.map = new Map({
            // OFM: pripis avtorstva je obvezen (licenca OpenStreetMap / OpenMapTiles).
            controls: defaultControls({
                attribution: true,
                attributionOptions: { collapsible: false },
            }).extend([
            new ZoomToExtent({ extent: SLO_EXTENT }),
            new ScaleLine({ units: 'metric' }),
            ]),
            layers: [this.wmsBaseLayerActive],
            target: id,
            pixelRatio: 1,
            view: mapView,
        });

        // IMPORTANT: use arrow fn to keep 'this'
        this.map.on('singleclick', (evt: any) => {
            this.map.getLayers().forEach((layer: any) => {
            if (
                layer.get('selectable') === true &&
                layer.get('wms') === 'true' &&
                layer.getVisible() &&
                !this.isdisablemapclick
            ) {
                const src = layer.getSource?.();
                const url = src?.getFeatureInfoUrl?.(
                evt.coordinate,
                this.map.getView().getResolution(),
                this.map.getView().getProjection(),
                { INFO_FORMAT: 'application/json' }
                );

                if (!url) return;
                if (shiftKeyOnly(evt)) return;

                this.http.get<any>(url + '&feature_count=50').subscribe((r) => {
                const vectorSource = this.geojson2FeatureSource(r);
                const features = vectorSource.getFeatures();

                for (const f of features) {
                    f.set('layerID', layer.get('id'));
                    f.set('showinfo', layer.get('showinfo'));
                    this.selectInteractionFeature.getFeatures().push(f);
                }
                });
            }
            });
        });

        this.selectInteraction();

        // When the container resizes (legend/table/inner gutters), OL keeps the center
        // coordinate fixed but the visible area shifts — looks like the map panned.
        // Fix: preserve the top-left coordinate so the content doesn't appear to move.
        // The tree panel is a full-width overlay so it never changes the map container size.
        let prevTL: number[] | null = null;

        this.map.on('postrender', () => {
            prevTL = this.map.getCoordinateFromPixel([0, 0]) ?? null;
        });

        this.map.on('change:size', () => {
            if (!prevTL) return;
            const view = this.map.getView();
            const size = this.map.getSize();
            const res = view.getResolution();
            if (!size || res === undefined) return;
            view.setCenter([
                prevTL[0] + size[0] / 2 * res,
                prevTL[1] - size[1] / 2 * res,
            ]);
            prevTL = this.map.getCoordinateFromPixel([0, 0]) ?? prevTL;
        });
    }


    public disableMapCick(d:boolean)
    {
        this.isdisablemapclick = d;
    }

    public onMapLoad():Observable<Mapapi>
    {
        return this.$bhsMapLoad;
    }

    public setMapLoadDone()
    {
        this.bhsMapLoad.next(this);
    }



    private selectInteraction(): void {
        const self = this;

        const lineStyleSelected = this.linestyle.getLineStyle("#FF69B4", 5);
        const pointStyleSelected = this.pointstyle.getPointStyle("#FF69B4", 5);
        const polygonStyleSelected = this.polygonStyle.getPolygonStyleStyle("#FF69B4", 5, 0.5);

        this.selectInteractionFeature = new Select({
            layers: (layer: any) => layer.get('selectable') === true,

            // ZA MODUL SISTEMI DALJINSKEGA OGREVANJA --> RRI
            style: (feature: any) => {
            if (
                feature?.get?.('layerID') === 'district-heating-lines' ||
                feature?.get?.('layerID') === 'district-heating-houses'
            ) {
                return null;
            }

            return [lineStyleSelected, pointStyleSelected, polygonStyleSelected] as any;
            },

            condition: (evt: any) => {
            if (evt.type === 'click' && shiftKeyOnly(evt)) {
                this.selectInteractionFeature.getFeatures().clear();
                return false;
            }
            return evt.type === 'click';
            },
            hitTolerance: 5,
        });

        const selectedfeaturesClick = this.selectInteractionFeature.getFeatures();

        selectedfeaturesClick.on('remove', function(event: any) {
            const feature = event.element;
            self.evs.sendUnSelectOlFeature(feature);
            self.tabledataService.setSelectItemData(true, feature);
        });

        selectedfeaturesClick.on('add', function(event: any) {
            for (let a = 0; a < event.target.getLength(); a++) {
            const feature = event.target.item(a);
            feature.showinfo = true;
            self.evs.sendSelectOlFeature(feature);
            self.tabledataService.setSelectItemData(false, feature);
            }
        });

        this.map.addInteraction(this.selectInteractionFeature);
        }

    // OFM: NORMAL / CLASSIC / POSITRON = OpenFreeMap,
    //      HYBRID (ali MOL) = ortofoto (GURS + MOL za upravičene) + OpenFreeMap ceste in imena.
    //      Stare GK podlage so odstranjene in se ne kličejo nikoli več.
    //      Neznan tip (npr. stari 'SLOINFO') preklopi na NORMAL.
    setMapType(newType: string): void {
        let next: any;
        if (newType === 'HYBRID' || newType === 'MOL') {
            next = this.getHybridLayer();
        } else {
            next = this.getOfmLayer(OFM_STYLES[newType] ? newType : 'NORMAL');
        }

        if (next === this.wmsBaseLayerActive) return;

        if (this.wmsBaseLayerActive) {
            this.map.removeLayer(this.wmsBaseLayerActive);
        }

        this.wmsBaseLayerActive = next;

        // OFM: podlage se ne osvežujejo (brez _ck), da brskalnik uporabi predpomnilnik.
        this.map.getLayers().insertAt(0, next);
    }

    public getCenterOfFT(extentIN: any): any {
        const tr = applyTransform(extentIN, getTransform(Mapapi.activeEPSG, 'EPSG:4326'));
        return getCenter(tr);
    }

    public  resizeMap():void
    {
        if ( this.map !== undefined)
        {
            this.map.updateSize();
        }
    }

    public coordinate2point(coordinate: any): any {
        return new Point(coordinate);
    }

    // OFM: WKT iz baze je v GK, zato ga preslikamo v koordinatni sistem karte.
    // Če kdaj dobiš WKT, ki je že v 3857, pokliči wkt2Feature(t, 'EPSG:3857').
    public wkt2Feature(t: string, dataProjection: string = Mapapi.dataEPSG): any {
        const wkt = new WKT();
        return wkt.readFeature(t, {
            dataProjection,
            featureProjection: Mapapi.activeEPSG,
        });
    }

    // OFM: iz GeoJSON "crs" razbere EPSG kodo; podpira "EPSG:3912",
    // "urn:ogc:def:crs:EPSG::3912", "http://www.opengis.net/def/crs/EPSG/0/3912" in CRS84.
    private parseCrsName(name: string | undefined | null): string | null {
        if (!name) return null;
        if (/CRS84$/i.test(name)) return 'EPSG:4326';
        const m = /(\d{4,6})\s*$/.exec(name);
        return m ? 'EPSG:' + m[1] : null;
    }

    // OFM: če odgovor nima "crs", se privzame dataEPSG (GK), tako kot doslej.
    public geojson2FeatureSource(r: any, defaultDataProjection: string = Mapapi.dataEPSG): any {
        const dataProjection = this.parseCrsName(r?.crs?.properties?.name) ?? defaultDataProjection;

        const format = new GeoJSON();
        return new VectorSource({
            features: format.readFeatures(r, {
            featureProjection: Mapapi.activeEPSG,
            dataProjection,
            }),
        });
    }

    // OFM: extent mora biti v koordinatah karte (3857). Če imaš GK extent,
    // ga najprej pretvori: transformExtent(ext, 'EPSG:3912', 'EPSG:3857').
    public  fit(extent:any):void
    {

        this.map.getView().fit(extent, this.map.getSize(),{constrainResolution: false});
    }


    public selectFeature(f: any): void {
        console.warn("selectFeature CALLED", f);

        this.selectInteractionFeature.getFeatures().push(f.clone());
        this.map.getView().fit(f.getGeometry().getExtent(), this.map.getSize());
    }


    private unselectFeature(fa:any , layer:any)
    {

        var self = this;

        if (fa !== undefined && fa !== null )
        {

            if (layer !== null)
            {
                fa.forEach(function(feature: any)
                {
                        if (feature !== undefined)
                        {
                            if (feature.get("layerID") !== undefined)//wms
                            {
                               if( layer.get("id") === feature.get("layerID") )
                               {
                                   if (self.selectInteractionFeature.getFeatures().getLength() > 0)
                                       self.selectInteractionFeature.getFeatures().remove(feature);

                               }
                            }
                            else if(feature.getId() !== undefined )
                            {
                                if ( layer.get("id") === feature.getId())
                                {
                                    if (self.selectInteractionFeature.getFeatures().getLength() > 0)
                                        self.selectInteractionFeature.getFeatures().remove(feature);

                                }
                            }
                            else if (layer.getSource() != null && typeof layer.getSource().getFeatures === "function")
                            {

                                layer.getSource().getFeatures().forEach(function(lf: any)
                                {
                                    if (self.selectInteractionFeature.getFeatures().getLength() > 0)
                                        self.selectInteractionFeature.getFeatures().remove(lf);

                                })
                            }
                        }
                });
            }
        }
    }

    public  unselectFeatureForLayer(layer:any):void
    {
        var faIf:any = this.selectInteractionFeature.getFeatures();
        this.unselectFeature(faIf,layer);
    }

    public  unselectAllFeatures():void
    {
        var faIf:any = this.selectInteractionFeature.getFeatures();
        faIf.clear();
    }

    public  unselectFeatureByFtId(id:any):void
    {

        var faIf:any = this.selectInteractionFeature.getFeatures();
        faIf.forEach(function(f: any)
        {
           if (f.getId() === id)
           {
               faIf.remove(f);
           }

        });
    }

    public  unselectFeatureByFeature(feature:any):void
    {

        var faIf:any = this.selectInteractionFeature.getFeatures();
        faIf.forEach(function(f: any)
        {
           if (f !== undefined && f.getId() === feature.getId())
           {
               faIf.remove(f);
           }

        });
    }

    public removeAllLayers():void
    {
        var self = this;
        var markforRemove: any = [];
        self.map.getLayers().forEach(function(layer: any)
        {
            if (layer.get('dynamic') != undefined && layer.get('dynamic') == "true")
            {
                markforRemove.push(layer);

            }

        });
        for (var a = 0; a < markforRemove.length;a++)
        {
            self.removeLayerById(markforRemove[a].get("id"));
        }
    }

    public showLayerById(id: string, visible: boolean): void {
        const layer = this.getLayerById(id);
        if (layer !== null) {
            layer.setVisible(visible);
            if (visible) {
                this.refreshSource(layer);
            }
        }
    }

    public getLayerById (id:string):any
    {

        var self = this;
        var found = null;

        self.map.getLayers().forEach(function(layer: any)
        {
            if(layer.get('id') !== undefined && String(layer.get('id')) === String(id) )
            {
                found = layer;

            }
        })

        return found;
    }

    public hideAllLayers():void
    {
        var self = this;
        var markforHide: any = [];
        self.map.getLayers().forEach(function(layer: any)
        {
            if (layer.get('dynamic') != undefined && layer.get('dynamic') == "true")
            {
                markforHide.push(layer);

            }

        });
        for (var a = 0; a < markforHide.length;a++)
        {
            self.showLayerById(markforHide[a].get("id"),false);
        }
    }

    public removeLayerById (id:string):void
    {
        this.map.removeLayer( this.getLayerById(id));
    }


    public layerExists (id:string):boolean
    {
        return (this.getLayerById(id) !== null)
    }


    public createHeatLayer(
        source: VectorSource,
        radius: number,
        blur: number,
        title: string,
        weightFunction: (f: any) => number,
        id: number
        ): void
    {
        const heatLayer = new HeatmapLayer({
            source,
            radius,
            blur,
            weight: (f) => weightFunction(f),
        });

        heatLayer.set('title', title);
        heatLayer.set('selectable', false);
        heatLayer.set('id', id);
        heatLayer.set('dynamic', 'true');
        heatLayer.set('showinfo', false);
        heatLayer.set('heat', 'true');

        this.map.addLayer(heatLayer);
    }

    // OFM: brez sprememb. TileWMS brez "projection" zahteva slike v 3857,
    // GeoServer pa jih sam preslika iz GK (ostro, GetFeatureInfo deluje).
    public createTileWMSLayer(
        url: string,
        layer: string,
        id: string,
        cqlonstart: string,
        info: boolean,
        select: boolean
    ): void {
        const existing = this.getLayerById(id);
        if (existing !== null) {
            this.map.removeLayer(existing);
        }

        const params: any = {
            LAYERS: layer,
            TILED: true,
            _ck: this.nextCacheKey()
        };

        if (cqlonstart != null && cqlonstart.length > 0) {
            params.CQL_FILTER = cqlonstart;
        }

        const blend = LAYER_BLEND_MODES[layer];

        const tmsl = new TileLayer({
            // OFM: sloj z načinom mešanja dobi svoj canvas, da se meša s sloji pod njim.
            className: blend ? 'ol-layer ol-blend-layer' : 'ol-layer',
            source: new TileWMS({
                url: url + '/wms',
                params,
                serverType: 'geoserver',
            }),
        });

        if (blend) {
            tmsl.on('prerender', (evt: any) => {
                const el = evt.context?.canvas?.parentElement as HTMLElement | null;
                if (el && el.style.mixBlendMode !== blend) {
                    el.style.mixBlendMode = blend;
                }
            });
        }

        tmsl.set('id', id);
        tmsl.set('dynamic', 'true');
        tmsl.set('wms', 'true');
        tmsl.set('showinfo', info);
        tmsl.set('selectable', select);

        this.map.addLayer(tmsl);
        this.refreshSource(tmsl);
    }


    public createWfsLayer(
        url: string,
        layer: string,
        id: string,
        cqlonstart: string,
        info: boolean,
        select: boolean
    ): void {
        if (url.trim().length === 0) return;

        const existing = this.getLayerById(id);
        if (existing !== null) {
            this.map.removeLayer(existing);
        }

        const source = new VectorSource({
            // OFM: GeoServer vrne podatke že v 3857 (srsName spodaj).
            format: new GeoJSON({
                dataProjection: Mapapi.activeEPSG,
                featureProjection: Mapapi.activeEPSG,
            }),
            url: () => {
                const ck = this.nextCacheKey();
                const base =
                    `${url}/ows?outputFormat=application/json` +
                    `&service=WFS&version=1.0.0&request=GetFeature&typeName=${layer}` +
                    `&srsName=${Mapapi.activeEPSG}` +
                    `&_ck=${ck}`;

                if (cqlonstart != null && cqlonstart.length > 0) {
                    return `${base}&cql_filter=${encodeURIComponent(cqlonstart)}`;
                }

                return base;
            },
            strategy: loadingStrategyAll,
        });

        const lineStyle = this.linestyle.getLineStyle('#248c61', 3);
        const pointStyle = this.pointstyle.getPointStyle('#DC143C', 3);

        const vector = new VectorLayer({
            source,
            style: [lineStyle, pointStyle] as any,
        });

        vector.set('selectable', select);
        vector.set('id', id);
        vector.set('dynamic', 'true');
        vector.set('showinfo', info);
        vector.set('wfs', 'true');

        this.map.addLayer(vector);
        source.refresh();
    }



    public  parseTableDataWFS_WMS(s:any , layerID:any):any
    {
        //console.log("reload table : size is = "+s.getFeatures().length);
        var data: any = [];
        if (s === undefined || s.getFeatures() === undefined || s.getFeatures().length === 0)
        {
            return {data:[{" ":"Ni podatkov"}],fields:[{field:" ",header: " ",hidden:false}]};
        }

        let keys = Object.keys(s.getFeatures()[0].getProperties());
        let fields = [];
        for (let k in keys)
        {



            if (keys[k] === 'geometry' || keys[k].charAt(0) === "_" )
            {
                fields.push({field: keys[k], header: keys[k] , hidden:true});
            }
            else
            {
                let fldName =  keys[k].replace(new RegExp('_', 'g'), ' ');
                fields.push({field: keys[k], header: fldName , hidden:false});
            }
        }



        s.forEachFeature(function(ft: any)
        {
            var obj: any = {};
            ft.set("layerID",layerID);
            ft.set("ftID",ft.getId());
            var attributes = ft.getProperties();

            for (var atr in attributes)
            {

                   var v =  attributes[atr];
                   if (atr === 'geometry')
                   {
                       v = ft;

                   }
                   obj[atr] = v;

            }

            data.push(obj);
        }.bind(this));
        return {data:data,fields:fields};
    }



    public saveWFSTTransaction(operation: string, f: any, info: any): void {
        const xs = new XMLSerializer();
        const formatWFS = new WFS();

        const clonedFeature = f.geometry.clone();
        clonedFeature.setId(f.geometry.getId());
        clonedFeature.unset('layerID');
        clonedFeature.unset('geometry');

        const np = clonedFeature.getProperties();
        const keys = Object.keys(np);

        for (const k of keys) {
            const val = f[k];
            clonedFeature.set(k, val);
        }

        // OFM: geometrijo pred shranjevanjem vrnemo v GK, da gre v bazo
        // v enakem sistemu kot prej (ne zanašamo se na preslikavo na GeoServerju).
        const geom = clonedFeature.getGeometry?.();
        if (geom) {
            geom.transform(Mapapi.activeEPSG, Mapapi.dataEPSG);
        }

        const formatGML = new GML({
            featureNS: info.node.data.layer.split(':')[0],
            featureType: info.node.data.layer.split(':')[1],
            srsName: Mapapi.dataEPSG,
        });

        let node: any;

        switch (operation) {
            case 'update':
            node = formatWFS.writeTransaction(null as any, [clonedFeature], null as any, formatGML as any);
            break;
            default:
            return;
        }

        this.http
            .post(info.node.data.url + '/wfs', xs.serializeToString(node), {})
            .pipe(map((response) => response))
            .subscribe();
    }

    public zoomToFeature(feature: any): void {
        const geom = feature && feature.getGeometry && feature.getGeometry();
        if (!geom) return;

        const extent = geom.getExtent();

        // če imaš map view:
        this.map.getView().fit(extent, {
            padding: [40, 40, 40, 40],
            duration: 250,
            maxZoom: 19
        });
    }

    // OFM: bbox je zdaj v 3857. Klicatelj mora GeoServerju poslati SRS iz "srs"
    // (npr. &SRS=EPSG:3857 ali &CRS=EPSG:3857), sicer bo izvoz napačen.
    public getExportView(): { bbox: string; width: number; height: number; srs: string } {
        const size = this.map.getSize();
        const extent = this.map.getView().calculateExtent(size);
        return {
            bbox: extent.join(','),
            width: Math.min(4096, Math.round(size[0])),
            height: Math.min(4096, Math.round(size[1])),
            srs: Mapapi.activeEPSG
        };
    }
}